import { Outlet } from 'react-router-dom';
import WorkspaceShell from '@/components/layout/WorkspaceShell';
import OnboardingSidebar from './OnboardingSidebar';

const OnboardingLayout = () => (
  <WorkspaceShell
    sidebar={<OnboardingSidebar />}
    mainClassName="onboarding-layout__main w-full">
    <Outlet />
  </WorkspaceShell>
);

export default OnboardingLayout;
